var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _vm.sessionInfo
        ? _c(
            "div",
            { staticClass: "page-header" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("会话ID：")]),
                      _c("span", [_vm._v(_vm._s(_vm.sessionInfo.sessionId))]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("会话标题：")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.sessionInfo.sessionTitle || "无标题")
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("avue-crud", {
        ref: "crud",
        attrs: {
          option: _vm.option,
          "table-loading": _vm.loading,
          data: _vm.data,
          page: _vm.page,
        },
        on: {
          "current-change": _vm.currentChange,
          "size-change": _vm.sizeChange,
          "refresh-change": _vm.refreshChange,
        },
        scopedSlots: _vm._u([
          {
            key: "msgType",
            fn: function (scope) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.getMsgTypeColor(scope.row.msgType),
                      size: "small",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getMsgTypeText(scope.row.msgType)) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "sendUserType",
            fn: function (scope) {
              return [
                _c("el-tag", { attrs: { size: "small" } }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getSendUserTypeText(scope.row.sendUserType)) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "reponseMills",
            fn: function (scope) {
              return [
                _c("span", [_vm._v(_vm._s(scope.row.reponseMills || "0"))]),
              ]
            },
          },
          {
            key: "uid",
            fn: function (scope) {
              return [_c("span", [_vm._v(_vm._s(scope.row.uid || "-"))])]
            },
          },
          {
            key: "content",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "message-content" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.content,
                          placement: "top",
                          disabled:
                            !scope.row.content ||
                            scope.row.content.length <= 50,
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.truncateText(scope.row.content, 50))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "menu",
            fn: function (scope) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      size: "small",
                      icon: "el-icon-s-order",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleViewTasks(scope.row)
                      },
                    },
                  },
                  [_vm._v("\n        查看任务\n      ")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }